import type { ModulePermissionShape } from "@/types/permissions";

export const roleBasedAssignmentsPermissionKeys = [
  "role_based_project_rates_export",
] as const;

export type RoleBasedAssignmentsPermissions = ModulePermissionShape<
  typeof roleBasedAssignmentsPermissionKeys
>;
